/**
 * API client for MQTT/IoT OTA firmware updates
 * Uses mqtt-service-staging endpoints
 */

const MQTT_SERVICE_URL = import.meta.env.VITE_MQTT_SERVICE_URL || '';

export interface MqttOtaUpdate {
  id: number;
  device_sn: string;
  firmware_url: string;
  filename: string | null;
  file_size: number | null;
  status: string;
  source: string;
  sent_at: string;
  acked_at: string | null;
  error_message: string | null;
}

export interface MqttOtaDevice {
  device_sn: string;
  online: boolean;
  ws_connected: boolean;
  last_seen: string | null;
  fw_version: string | null;
}

export const mqttOtaApi = {
  async getHistory(deviceSn?: string): Promise<{ success: boolean; data: MqttOtaUpdate[] }> {
    const params = deviceSn ? `?device_sn=${deviceSn}` : '';
    const res = await fetch(`${MQTT_SERVICE_URL}/api/v1/ota/history${params}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },

  async getDevices(): Promise<{ success: boolean; data: MqttOtaDevice[] }> {
    const res = await fetch(`${MQTT_SERVICE_URL}/api/v1/ota/devices`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },

  async uploadFirmware(file: File): Promise<{ success: boolean; message?: string; data?: { filename: string; size: number; url: string }; error?: string }> {
    const formData = new FormData();
    formData.append('firmware', file);
    const res = await fetch(`${MQTT_SERVICE_URL}/api/v1/ota/upload`, {
      method: 'POST',
      body: formData,
    });
    return res.json();
  },

  async triggerOta(deviceSn: string, firmwareUrl: string): Promise<{ success: boolean; message?: string; data?: { ota_id: number; device_sn: string; status: string; delivered: boolean }; error?: string }> {
    const res = await fetch(`${MQTT_SERVICE_URL}/api/v1/devices/${deviceSn}/ota`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ firmware_url: firmwareUrl }),
    });
    return res.json();
  },
};
